// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as ReactIntl from "react-intl";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import PlaceStatsModuleCss from "./PlaceStats.module.css";

let classes = PlaceStatsModuleCss;

function PlaceStats(props) {
  let tmp;
  if (props.isUserAuthorized(80)) {
    let newrecord = {...RouterUtils.createAnchorProps(undefined, "./osob")};
    tmp = <a
      {...newrecord} 
      type={"button"}
      className={Styles.button.base}
    >
      {"Osobní účty"}
    </a>;
  } else {
    tmp = null;
  }
  return <SectionWithHeader.make
    buttonsSlot={tmp}
    headerId={"accounting_overview"}
    headerSlot={"Účetnictví"}
  >
    <dl
      className={classes.descriptionList}
    >
      <dt>
        {"Počet hostů"}
      </dt>
      <dd>
        <ReactIntl.FormattedNumber
          value={props.personsCount}
        />
      </dd>
      <dt>
        {"Sudy na skladě"}
      </dt>
      <dd>
        <FormattedCurrency.make
          value={props.chargedKegsValue}
        />
      </dd>
    </dl>
  </SectionWithHeader.make>;
}

let make = PlaceStats;

export {
  classes,
  make,
}
/* classes Not a pure module */
